import {isFeatureEnabled} from '@github-ui/feature-flags'

export function isMarketingNavigationRedesignEnabled(): boolean {
  return isFeatureEnabled('site_marketing_navigation_ia') && isFeatureEnabled('site_marketing_navigation_redesign')
}
